// extracted by mini-css-extract-plugin
module.exports = {"news_group":"news_group-G8j50iRw","news_group_title":"news_group_title-2KHOkCRz","block":"block-21IakHTj","link_title":"link_title-1NAVs31A","more":"more-1Xggor0v"};